import { useContext } from 'react'
import styled from 'styled-components'

import { Globals } from '@h2/globals'
import { PB97T, WHITE } from '@h2/components/colors'

/**
 * Helps control whitespace between main content area
 * and site footer until the server-side rendering can
 * be removed and the global layout is react-based.
 */
const defaultBottomSpace = '40px'
const Grid = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ isNavianceUser }) => (isNavianceUser ? 0 : defaultBottomSpace)};
  background-color: ${({ isNavianceUser }) => (isNavianceUser ? PB97T : WHITE)};
`
/**
 * Some UI's require there to be no whitespace between the
 * footer (which is server-side rendered) and the main content
 * area. Rendering this at the bottom of the page content
 * will collapse the whitespace.
 */
const CollapseBottomWhitespace = styled.div`
  margin-bottom: -${defaultBottomSpace};
`
const Layout = ({ children }) => {
  const { isNavianceUser } = useContext(Globals)

  return <Grid isNavianceUser={isNavianceUser}>{children}</Grid>
}

export { Layout, CollapseBottomWhitespace }
